module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter One")])])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("February 1817")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("‘A")])])])]), _vm._v("nd so, my false love—I die!’ The maiden sank to the ground, a dagger in her bosom, her white arm outflung.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The audience went wild. They applauded, whistled, stamped and, those members of it who were not weeping into their handkerchiefs, leapt to their feet with cries of ‘More! More!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The dark-haired lady in the expensive box close to the stage gripped the velvet-upholstered rim and held her breath. For the audience who had flocked to see the final performance of "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Sicilian Seducer, or Innocence Betrayed,")])]), _vm._v(" the tension was over and they could relax into their appreciation of the melodrama. For Lady Maude Templeton, the climax of the evening was about to occur and, she was determined, it would change her life for ever.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You would never guess it, but she must be forty if she’s a day,’ Lady Standon remarked, lowering her opera glass from a careful study of the corpse who was just being helped to her feet by her leading man.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('span', [_vm._v("‘One is given to understand that La Belle Marguerite never ")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("mentions anything so sordid as age, Jessica.’ Her husband turned from making an observation to Lord Pangbourne.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("‘Fine figure of a woman,’ the earl grunted. He was still applauding enthusiastically. ‘Not surprising that she was such a sensation on the Continent.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("‘And so much of that figure on display,’ Jessica murmured to Maude, who broke her concentration on the shadowy wings long enough to smile at her friend’s sly remark. The loss of focus lasted only a moment. Tonight was the night, she knew it. With the excitement that surrounded a last night at the Unicorn she had her best opportunity to slip backstage. And once she was there, to make what she could of the situation.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("Then her breath caught in her throat and her heart beat harder, just as it always did when she glimpsed him. Eden Hurst, proprietor of the Unicorn theatre, strode on to the stage and held up both hands for silence. And by some miracle—or sheer charisma—he got it, the tumult subsiding enough that his powerful voice could be heard.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("‘My lords, ladies, gentlemen. We thank you. On behalf of Madame Marguerite and the Company of the Unicorn, I thank you. Tonight was the last performance of "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Sicilian Seducer")])]), _vm._v(" for this, our first full Season.’ He paused while exaggerated groans and shouts of ‘shame!’ resounded through the stalls and up into the gods. ‘But we are already looking forward to "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Her Precious Honour")])]), _vm._v(" to open in six weeks’ time and I can assure her many admirers that Madame Marguerite will take the leading role in this dramatic tale of love triumphant over adversity. Good night to you all and I hope to welcome you next week for our revival of that old favourite, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("How to Tease and How to Please")])]), _vm._v(", with the celebrated Mrs Furlow in the leading role.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("‘Damn good comedy that,’ Lord Pangbourne pronounced, ")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("getting to his feet. ‘I recall it when it first came out. In ’09, was it? Or the year after?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Maude did not hear her father. Down below in the glare of the new gas lights stood the man she desired, the man she knew she could love, the man she had wanted ever since she had first seen him a year before.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Since then she had existed on the glimpses she had caught of him. In his theatre she sat imprisoned, in a box so close she could have almost reached down and touched him. On the rare occasions he had attended a social function where she had been present he had been frustratingly aloof from the unmarried ladies, disappearing into the card rooms to talk to male acquaintances or flirting with the fast young widows and matrons. And even she, bold as she was, could not hunt down a man to whom she had not been introduced and accost him. Not in the midst of a society ball and not a man of shady origins who had arrived in England trailing a tantalising reputation for ruthless business dealing and shocking "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("amours")])]), _vm._v(".")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("And last Season he had closed the Unicorn for renovations and returned to the Continent for a tour with his leading lady only months after they had arrived in England.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Standing there, he dominated the stage by sheer presence. Tall, broad-shouldered, with an intense masculine elegance in his dark coat and tight pantaloons, yet somehow flamboyant and dramatic. Maude caught the sharp glitter of diamonds at his throat and from the heavy ring on his left hand and recognised that his clothes had been cut with an edge of exaggeration that would be out of place in a polite drawing room. He was a showman, demanding and receiving attention just as much as the most histrionic actor.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("‘Maude.’ Jessica nudged her. ‘One of these evenings your ")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("papa is going to notice that you dream through the performances and only wake up when Mr Hurst is on stage.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("‘I don’t dream,’ she contradicted, finally getting to her feet as Eden Hurst walked off stage to loud applause. ‘I am watching and I am listening. I have to learn how this place works.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("She had never managed to speak to him. The only words he had spoken in her presence had been to a shopkeeper while she, the bright, lively, witty Lady Maude had stood in Mr Todmorton’s perfume shop, struck dumb by the sheer beauty of the man. But three days ago, thanks to an overheard conversation at Lady Robert’s otherwise dull reception, she had discovered that Mr Hurst had been making discreet approaches to potential investors. And that, she realised, gave her the perfect excuse.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("Now she must have her wits about her as she followed her father and the Standons down to the main lobby of the Unicorn. Parties were gathering and chattering beneath the famous clock that hung from the neck of the one-horned beast charging out of the wall like a ship’s figurehead. As she had hoped, Jessica stopped to speak to a friend. Gareth, her husband, waited patiently beside her while Maude slid through the crowd to her father’s side.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("‘Papa, Jessica invited me to drive home with her and to spend the night,’ she said as he clicked his fingers at the attendant for their cloaks. It was quite true, Jessica had done just that and Maude had thanked her nicely and explained that she thought her papa would expect her home tonight.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("Which was also true, so very gratifyingly she had told no actual untruths. And she was, after all, a lady of resource with money in her reticule who was perfectly capable of finding herself a hackney carriage. Eventually.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("‘Very well, my dear.’ Lord Pangbourne craned to see the ")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("Standons in the crush. ‘I’ll see you at dinner tomorrow. Say all that is right to Lady Standon for me, won’t you? I can’t fight my way through this like you slender young things.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("‘Yes, Papa.’ Maude watched until he was outside and then slipped through the door to one side of the entrance. She was not certain where it went, other than backstage. But that was enough for her purposes.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("‘Can I help you, miss?’ She was in a passageway, as brown and dingy as the lobby was brilliant and gilded. Maude dragged in a deep breath compounded of oil and dust, gas fumes, overcrowded hot people and greasepaint, and smiled brilliantly at the youth who had paused in front of her. His arms were full of hothouse flowers, an incongruous contrast to his shirtsleeves and baize apron.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("‘Mr Hurst’s office, if you please.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("‘The Guv’nor, miss?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("‘Yes,’ Maude said firmly. ‘The Guv’nor. I have a proposition for him.’")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("Eden Hurst tugged his neckcloth loose from amidst the heavy ruffles of his shirt, flung himself into his great carved chair and put his feet up on his desk. Ten minutes of peace and quiet, he promised himself. Then back down the corridor to Madame’s room to flatter and reassure in the midst of enough blooms to fill a conservatory.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("Why she needed reassurance after a reception like tonight, Heaven only knew, but he had sensed a petulance that must be soothed. Ever since she had reluctantly agreed to return to England after years on the Continent she had been on edge, more demanding, more insecure, and the return tour while the renovations were carried out had only made things worse.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("Perhaps the light of the new gas lamps was unkind when ")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("her dresser finally creamed away the greasepaint. He would have the oil lamps on their stands brought back into her dressing room. Anything to keep the star of the Unicorn happy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Feet still on the desk, he leaned forward and reached for his notebook to add "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("oil lamps")])]), _vm._v(" to the never-ending list of things to be done. His groping fingers nudged a pile of stiff cards, sending them to the floor. They lay face up, yesterday’s social obligations.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Eden dropped his head back and stared at the ceiling, oblivious to the cracks that created fantasy maps over its grey surface. Was it worth it, allowing himself to be lionised by Corwin and his vulgar wife? He shut his eyes, annoyed with himself for revisiting a decision that had already been made. He needed an investor if he was to continue to make the improvements the Unicorn needed to keep it in the forefront of London’s smaller theatres, and he needed a damned sight more cash than the gas lights had cost him if he were to finally persuade the owner to sell it to him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Through his agents he had bought several small theatres around the country over the past two years as investments, leaving them in the hands of managers while he continued to tour Europe with Madame. Then had come word of the kind of theatre he had been dreaming of ever since he had stepped on to a stage, and he sold them all to raise the money to restore the Unicorn. It had meant coming to England and it had meant risking everything on a building that was not his own, but Eden Hurst had learned to trust his gut instincts in business and was prepared to be ruthless with himself, and with Madame, if necessary.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("He could stomach Corwin, even Mrs Corwin in her purple toque, at a pinch. What was tightening his gut was the thought of the simpering Misses Corwin: Miss Calliope, Miss ")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("Calenthe and Miss Coraline. One of them was the price Corwin was going to ask for his investment, Eden was sure. He’d marry a Corwin daughter over his dead body and he’d been certain of managing the thing tactfully in the end. Certain—until he’d heard the girls giggling and plotting together in the overheated conservatory.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("No time to think about that now. He lowered his feet back to the threadbare Turkey carpet, twitched his neckcloth into order and ran his hands through his over-long hair. Outside his office the corridor was deserted, with all the noise and the activity coming from the stage where they were striking the sets in one direction, and the Green Room where the actors were entertaining their friends and admirers in the other.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Eden took a deep breath and stopped. Gardenia was not a familiar scent in the utilitarian passage outside his office door. Nor was the rustle of silk skirts from the shadows expected. As he realised it, he saw her, an indistinct form in the alcove opposite. Young, slender—he could tell that from the way she moved, the glimpse of white skin at neck and breast.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Those accursed girls.")])]), _vm._v(" He had thought himself safe for a day or two while they perfected their scheme to ensure that one of them was comprehensively compromised by him. But, no, here was the first of them, it was irrelevant which. If he pretended not to have seen her and went to the Green Room, she would be into his office, probably prepared to strip off for maximum effect when he returned, with or without a witness. And he was damned if he was going to stand here and shout for help in his own theatre, which seemed the only other option.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Or was it? Perhaps he could scare the living daylights out of her. Eden smiled grimly, took a long step forward and ")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("caught the half-seen figure by the shoulders. She came easily, with a little gasp, like a maid into her lover’s arms, he thought with habitual cynicism, just before he took her mouth. Hard.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("She had been kissed before. At the age of twenty-five, and after several Seasons energetically avoiding becoming betrothed, Maude had flirted with sufficient young gentlemen and had dallied in enough drawing rooms to have experienced everything from gauche wet ineptitude, to boldly snatched kisses, to shyly gentle caresses.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("But she had never been kissed by a man who knew what he was doing and had no inhibitions about doing it thoroughly. How he managed it she had no idea, but one minute she was hiding in a dark alcove, poised to step forward and introduce herself, and the next she was moulded against the long hard body of a male who was quite frankly and obviously aroused, whose lips were crushed to hers and whose tongue was taking full possession of her mouth.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("For a moment she froze, passive with shock in his grip. Then her mind began to work and caught up with her body, already pliant in his arms. It was Eden Hurst who was kissing her. She had dreamt of this for months and now it was happening. Hazily she acknowledged that he had no clue who she was and that he also appeared to be thoroughly out of temper, but just now that did not matter.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Maude found her fingers were laced in his hair, that romantic mane of black that gave him such an exotic appearance. Her breasts were pressed to his chest so that the swell of her bosom was chaffed by the brocade weave of his waistcoat and against hers his heart was beating, disconcertingly out of stroke with her pulse. But she was only peripherally aware of those tantalising discomforts. Her entire world was ")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("focused on what he was doing to her mouth and the devilish skill with which he was doing it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("Should a kiss make the soft flesh of her inner thighs quiver and ache? Should the insolent thrust of his tongue send shafts of desire deep into her belly, setting going an intimate pulse that made her want to twine her legs around his and press herself hard against him?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("He growled, a warning she did not heed, was incapable of taking, then his hands slid to cup her buttocks and he pulled her up against him so that the ridge of his erection pressed into the delta of her thighs. Now she knew what her body was searching for. Roughly he pushed her back to the hard wall, letting the movement rock them intimately until she was moaning in total surrender against his mouth.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("And then, just when she would have gone to the floor with him, done anything if only his mouth had stayed on hers, he released her, all but one hand, and stepped back. He reached behind him to fling open the office door and the light spilled out across her face when he tugged her into its path.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("‘Now let that be a lesson—hell and damnation,’ Eden Hurst said quietly, loosing her wrist. ‘You aren’t one of the Corwin girls.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("‘No, I am not.’ "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Thank God, I can still articulate")])]), _vm._v(". She reached out one hand to the wall beside her, unsure whether her legs would be as obedient as her voice. ‘I am Lady Maude Templeton, Mr Hurst.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("‘Then why the hell did you let me kiss you?’ he demanded with what she could only characterise as a total lack of reasonableness.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("‘One, you took me by surprise; two, you are somewhat stronger than I am; three, you are very good at it,’ she said coolly. This was not the moment to cast herself into his arms ")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("and declare her undying love. Besotted she might be, but she had her pride. One of these days he was going to tell her he loved her, but he needed to find that out for himself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘Well, I thank you for that last,’ he said on a disconcerting choke of laughter. ‘You are not inclined to slap my face?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Maude very much doubted that her legs would allow her to take the two steps necessary to achieve that. ‘No, I do not think so.’ It was so long since she had been close to him that now it did not seem there was enough air to breathe. Or else that kiss had dragged the air from her lungs. ‘Perhaps I should explain why I am here?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘You want a job, my lady? I need a costume mistress and a scene painter. Oh, yes, and a couple of handmaidens for the farce.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("He kept his face so straight that she could not decide whether he was totally literal or had a nasty sense of humour. ‘I doubt whether I would be suitable for any of those positions,’ she responded, deliberately matching his tone. ‘My sewing is poor, my painting worse and I would make a thoroughly heedless handmaiden. I have come to congratulate Madame Marguerite on her performance and to broach a matter of business with you, sir.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘Business?’ He studied her, expressionless. Maude was used to male admiration; this indifference piqued her, not unpleasantly. Her Mr Hurst was not in the common run of men. ‘Well, shall we start with Madame and then we can agree a more suitable time for a meeting tomorrow?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Maude would have thought him quite unmoved by what had just happened if it were not for the tension that seemed to flow from him, fretting her aroused nerves as though he had dragged a fingernail along her skin.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘You are without an escort, Lady Maude?’")])])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Yes,’ she said, daring him with her eyes to make something of it. ‘Perhaps you would be good enough to find me a cab later, Mr Hurst?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You are a practical woman it would appear, ma’am. And one with strong nerves as well as—’ He broke off. Maude turned her head to follow his gaze. From the direction she had come there were soft footsteps and the sound of nervous giggling. ‘Hell.’ He caught her hand again and pulled her into the office, closing the door behind them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Mr Hurst, I declare you appear quite hunted.’ Now she could see him clearly. The golden skin that always seemed lightly tanned, the dark brown eyes, the sensuous, sensual, mouth and the elegant, straight nose. She had been correct—those were diamonds in the pin at his throat and one old-fashioned cabochon stone in the barbarically heavy ring on his hand. And as he turned to face her, she saw another glinting in the lobe of his right ear. It should have looked effeminate, but it simply gave him the air of a pirate and she guessed that was quite deliberate.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Truer than you know, Lady Maude. Perhaps you would care to sit? I fear you are about to be the audience for a private performance of a farce.’ He gestured to a chair on one side of the desk and went to take the other, a great carved monstrosity of a throne with eagles on the back and lions’ heads on the arms")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The door inched open. More giggles, muffled, then a girl came in, her head turned to speak to someone outside. ‘Oh Calenthe, I am so nervous!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘But why should you be, Miss Corwin?’ Hurst enquired in a voice like sugar soaked in aloes. ‘You are amongst friends here.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The girl gave a shriek and dragged at the door to reveal her companion just behind it. Maude blinked at the sight of two thoroughly overdressed young women clinging together on the threshold.")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Lady Maude, may I introduce Miss Corwin and Miss Calenthe Corwin to your notice? Ladies, this is Lady Maude Templeton. I fear I cannot offer you refreshment as Lady Maude and I are discussing business.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maude, who was beginning to get some idea what was going on, enquired, ‘No doubt your mama is waiting for you close by?’ Their faces were so easy to read it was almost laughable. ‘No? Well, in that case I will take you home in my hackney, for you most certainly should not be out alone at this hour. Perhaps you would be so kind as to obtain one, Mr Hurst. I am afraid I must forgo the meeting with Madame this evening, but I do feel that seeing these misguided young ladies safe home must take priority. Shall we say eleven tomorrow to continue our discussion?’ She knew she sounded about fifty, but her tone was certainly having a dampening effect on the girls.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Certainly, ma’am.’ He might not be a professional actor, but the manager of the Unicorn could dissimulate like a master. His face showed nothing but a slightly obsequious attention to Maude and a faint irritation directed at the two younger women, as though at the antics of a pair of badly trained puppies.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maude swept out into the corridor, amazed to find her legs steady again. Who these two girls were she had no idea, other than that they were certainly not of the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("ton,")])]), _vm._v(" but she had no way of knowing if they would gossip about her. It was imperative that she kept them on the defensive, more worried about their own position than speculating about what the daughter of an earl was doing unchaperoned in Mr Hurst’s office at eleven in the evening.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("He led them through a maze of corridors and out into the night. Maude drew her veil down over her face and raised the ")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("hood of her cloak to shield her face from the crowd of gentlemen who were milling around the stage door, inside and out, while the stage door-keeper produced a hackney with a blast on his whistle. She allowed Mr Hurst to seat her in the vehicle before he stood back to allow the Misses Corwin to scramble in unaided. ‘Thank you, sir.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘Thank you, ma’am. Until eleven, then.’ He stopped to give the driver an address in the city, then turned away as the carriage rattled out into the late evening bustle of Long Acre.")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Maude waited with interest to see what her two companions would say now they were alone with her. In the gloom of the carriage they fidgeted, whispered and eventually one of them blurted out, ‘You won’t tell anyone, will you, Lady Maude?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘What exactly do you not wish me to reveal?’ she enquired coolly, finding herself irrationally annoyed with the pair of them. Why she should feel so protective of Eden Hurst she had no idea. He was more than capable of looking after himself, if their encounter in the corridor was anything to go by. If he had pounced on one of these girls in that manner, she would have fled screaming, just as he intended, no doubt. They quite obviously had not got a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("tendre")])]), _vm._v(" for him, either of them, so what on earth were they about, risking ruin like this?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘That we were trying to…um, encourage Mr Hurst into making an offer,’ the shorter one ventured.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘For which of you?’ Maude enquired, intrigued. Yes, he had known about this plot and had mistaken her in the gloom for one of these silly girls.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘With any of us. Mama thinks he will, because he wants Papa to invest in his theatre, but we aren’t sure because he never takes any notice of us. We don’t understand it,’ she added naïvely, ‘because we are ever so well dowered.’")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Perhaps Mr Hurst already has an attachment?’ Maude ventured, finding her irritation turning into something more like amusement until she realised that might very well be the case. She had no idea—Eden Hurst was a very private man.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Well, if he has, it isn’t anyone from amongst the merchant families. Papa would know,’ the taller sister offered confidently. ‘And he can’t marry anyone in society, because of being a bastard.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That was a relief. Then Miss Corwin’s words sank in. ‘A…a what?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Bastard. Although Mama says not to use that word and say "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("love begotten")])]), _vm._v(", instead. But it doesn’t matter really, because his father was an Italian prince or something equally grand.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That would explain his colouring, Maude thought hazily. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Was")])]), _vm._v(" Eden Hurst illegitimate? She had never heard a whisper, although it was not the sort of thing mentioned in front of unmarried ladies. Oh, Lord, if he was, that would be another obstacle to overcome. Trade was bad enough, the scandalous world of theatre even worse. Being the love child of an Italian prince was hardly going to make it any better. Papa was going to have palpitations, poor man, when he was finally presented with Eden Hurst as a son-in-law.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The hackney cab stopped. ‘We’re home.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘And how do you propose to get in?’ Maude enquired. They did not appear to be too worried by the prospect.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Through the service area.’ The girl hesitated on the carriage step. ‘Thank you, Lady Maude.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Well, don’t do anything like this again. If I were you, I would not talk about this little adventure to anyone,’ she added repressively. ‘And please tell the driver to take me to Berkeley Square.’")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maude was deep in thought when the hackney came to a halt again. The door was stiff and the light from the flambeaux either side of the Standons’ house flickered wildly in the stiff breeze. She almost tripped getting down, then stood shivering while she fumbled in her reticule.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘All right, m’lady, Mr Hurst paid,’ the man said, leaning round to slam the door shut.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Oh. How kind of him.’ Maude felt very tired all of a sudden. The shallow steps up to the front door seemed endless as she looked at them. Her hopes for the evening had been vague, beyond making contact with Eden Hurst, but she had not expected to be ruthlessly kissed and then find herself chaperoning two girls.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘He’s come along to see you home,’ the man added over his shoulder as the horse moved off.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As she stared across the corner of the square she saw another hackney drawn up, a tall figure standing by its open door. He raised a hand in acknowledgement as he saw her looking at him, then climbed back in. Maude drew her cloak around her and ran up the steps to Jessica’s house, no longer tired.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7613abcd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notoriousmrhurstthe_ch01.vue
// module id = 96
// module chunks = 0